import { render, staticRenderFns } from "./board_mobile.vue?vue&type=template&id=7f8c2888&scoped=true&"
import script from "./board_mobile.vue?vue&type=script&lang=js&"
export * from "./board_mobile.vue?vue&type=script&lang=js&"
import style0 from "./board_mobile.vue?vue&type=style&index=0&id=7f8c2888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c2888",
  null
  
)

export default component.exports